import { useEffect, useState } from "react"
import { APIS } from "../../../config/apis"
import { REQUEST_METHOD } from '@laramie/ui';
import { ServerRequest } from "../../../utils/apiweb"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import {TIPS} from "../../../consts/tips";

import { isNull, isValidNumber } from "../../../utils/validator"
import { CheckboxButton, CheckboxButtonGroup, FormError, FormLabel, InputColor, InputLista, Modal } from "../../common"
import { useForm, useFormErrors, useManagedContext } from "../../hooks"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"

const entityInit = {
    id: -1,
    codigo: '',
    orden: '',
    nombre: '',
    idTipoTributo: 0,
    tipo: '',
    color: '',
    inhibicion: false
}

const TipoCondicionEspecialModal = ({ editItem, editMode, onCancel, onConfirm }) => {
    const { setIsLoading } = useManagedContext()

    const [entity, setEntity] = useState(entityInit)
    const [formValues, formHandle, _formReset, formSet] = useForm({
        codigo: '',
        orden: '',
        nombre: '',
        idTipoTributo: 0,
        tipo: '',
        color: '',
        inhibicion: false
    })

    useEffect(() => {
        setEntity(editItem)
        formSet({
            codigo: editItem.codigo,
            orden: editItem.orden,
            nombre: editItem.nombre,
            idTipoTributo: editItem.idTipoTributo,
            tipo: editItem.tipo,
            color: editItem.color,
            inhibicion: editItem.inhibicion
        })
    }, [editItem])

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    function getErrors() {
        const errors = {}

        if (formValues.codigo.length < 1) errors.codigo = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (formValues.nombre.length < 1) errors.nombre = VALIDATION_MESSAGE.REQUIRED
        if (isEmptyValue(formValues.orden)) errors.orden = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (!isValidNumber(formValues.tipo, false)) errors.tipo = VALIDATION_MESSAGE.REQUIRED_SHORT

        return errors
    }

    function getFormatErrors() {
        const errors = {}
        if (editMode === 'view') return errors

        if (!isEmptyValue(formValues.orden) && !isValidNumber(formValues.orden, true)) errors.orden = 'Ingresá un número mayor a cero'
        if (formValues.color.length > 0 && formValues.color.length !== 6) errors.color = 'Debe tener 6 caracteres'

        return errors
    }

    function isEmptyValue(valor) {
        return isNull(valor) || valor.toString().length === 0
    }

    const onClickConfirm = () => {
        if (!validate()) return

        setIsLoading(true)

        ServerRequest(
            editMode === 'add' ? REQUEST_METHOD.POST : REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.TIPO_CONDICION_ESPECIAL,
            editMode === 'modify' ? `/${entity.id}` : '',
            { ...entity, ...formValues, orden: parseInt(formValues.orden) ?? 0 },
            res => res.json().then(() => {
                setIsLoading(false)
                onConfirm()
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            error => {
                onRequestError(error)
                setIsLoading(false)
            },
        )
    }

    const disabled = editMode === 'view'

    return (
        <Modal
            onEscape={onCancel}
            size="lg"
            title="Tipo de condición especial"
            tipName={TIPS.NAME.MODALS.ENTIDAD_MODAL}
            body={(
                <div className='row form-basic'>
                    <div className="col-12 col-md-6">
                        <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                        <input
                            type="text"
                            name="nombre"
                            className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                            value={formValues.nombre}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('nombre')} />
                    </div>
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="codigo" required>Código</FormLabel>
                        <input
                            type="text"
                            name="codigo"
                            maxLength={50}
                            className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                            value={formValues.codigo}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('codigo')} />
                    </div>
                    <div className="col-12 col-md-4">
                        <label htmlFor="idTipoTributo" className="form-label">Tipo de tributo</label>
                        <InputLista
                            name="idTipoTributo"
                            placeholder=""
                            className="form-control"
                            value={formValues.idTipoTributo}
                            onChange={formHandle}
                            disabled={disabled}
                            lista="TipoTributo"
                            textItemZero="Todos los tributos"
                        />
                        <FormError />
                    </div>
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="orden" required>Orden</FormLabel>
                        <input
                        name="orden"
                        type="number"
                        placeholder=""
                        className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
                        value={formValues.orden}
                        onChange={formHandle}
                        disabled={disabled}
                        />
                        <FormError message={errorOf('orden')} />
                    </div>

                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="orden" required>Tipo</FormLabel>
                        <input
                            name="tipo"
                            type="number"
                            placeholder=""
                            className={`form-control ${errorOf('tipo') ? 'is-invalid' : ''}`}
                            value={formValues.tipo}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('tipo')} />
                    </div>
                    <div className="col-12 col-md-2">
                        <label htmlFor="color" className="form-label">Color</label>
                        <InputColor
                            name="color"
                            placeholder=""
                            className={`form-control ${errorOf('color') ? 'is-invalid' : ''}`}
                            value={formValues.color}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('color')} />
                    </div>
                    <div className="col-12 col-md-3">
                        <CheckboxButtonGroup label="Opciones">
                            <CheckboxButton
                                name="inhibicion"
                                label="Inhibe la deuda"
                                checked={formValues.inhibicion}
                                onChange={formHandle}
                                disabled={disabled}
                            />
                        </CheckboxButtonGroup>
                    </div>
                </div>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                    {editMode !== 'view' && (
                        <button className="btn action-button" data-dismiss="modal" onClick={onClickConfirm}>Guardar</button>
                    )}
                </div>
                
            )}
        />
    )
}

export default TipoCondicionEspecialModal
